/* eslint-disable react/jsx-no-bind */
import { LinkTypeEnum } from '@hqo/hqo-miniapp-client-sdk';
import { MiniappSdkDemoInput } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-demo-input';
import { MiniappSdkRootMethodDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-root-method-demo';
import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

export const MiniappSdkRedirectToContentDemo = (): JSX.Element => {
  const intl = useIntl();
  const [value, setValue] = useState('');
  const [type, setType] = useState(LinkTypeEnum.NATIVE_LINK);
  const args = useMemo(() => [{ value, type }], [value, type]);

  return (
    <MiniappSdkRootMethodDemo action="redirectToContent" eventName="redirectToContentResponse" args={args}>
      <MiniappSdkDemoInput
        value={value}
        onChange={setValue}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.navigationValue' })}
        dataTestId="redirectToContentValue"
      />
      <MiniappSdkDemoInput
        value={type}
        onChange={(nextType) => setType(nextType as LinkTypeEnum)}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.linkType' })}
        dataTestId="redirectToContentType"
      />
    </MiniappSdkRootMethodDemo>
  );
};
